<template>
  <el-row class="web-preview-wrapper">
    <div class="web-layout">
      <div class="display-container">
        <img src="@/img/mobile-preview-bg.jpg" class="preview-background" />
        <div
          class="preview-wrapper"
          :class="[position === 'right' ? 'preview-right' : 'preview-left']"
          :style="wrapperStyles"
        >
          <inbox-preview
            :logo-url="logoUrl"
            :push-notification-switch="pushNotificationSwitch"
            :inbox-background-color="colors.inbox_background_color"
            :inbox-border-color="colors.inbox_border_color"
            :inbox-separator-color="colors.inbox_separator_color"
            :header-background-color="colors.header_background_color"
            :header-border-color="colors.header_border_color"
            :header-icon-color="colors.header_icon_color"
            :header-text-color="colors.header_text_color"
            :message-title-color="colors.notification_title_color"
            :message-text-color="colors.notification_text_color"
            :message-date-color="colors.notification_date_color"
            :switch-on-color="colors.switch_on_color"
          ></inbox-preview>
        </div>
      </div>
      <img width="450" src="@/img/mac.png" />
    </div>
  </el-row>
</template>
<script>
import InboxPreview from '@/modules/settings/components/InboxPreview'
export default {
  name: 'WebInboxPreview',
  components: { InboxPreview },

  props: {
    logoUrl: String,
    pushNotificationSwitch: Number,
    position: {
      type: String,
      validator: value => {
        return ['left', 'right'].indexOf(value) !== -1
      }
    },
    colors: Object
  },
  computed: {
    wrapperStyles() {
      return {
        backgroundColor: this.colors.inbox_background_color,
        boxShadow: `0px 3px 6px ${this.colors.inbox_border_color}`
      }
    }
  }
}
</script>

<style scoped>
.web-preview-wrapper {
  min-width: 300px;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  position: relative;
  overflow: hidden;
}
.web-layout {
  display: block;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0%);
  -webkit-transform: translate(-50%, 0%); /* Safari and Chrome */
  -moz-transform: translate(-50%, 0%); /* Firefox */
  -ms-transform: translate(-50%, 0%); /* IE 9 */
  -o-transform: translate(-50%, 0%); /* Opera */
}
.display-container {
  width: 315px;
  height: 429px;
  background-color: white;
  position: absolute;
  left: 120px;
  top: 37px;
  overflow: hidden;
}
.preview-wrapper {
  width: 80%;
  height: 100%;
  background-color: #95a2ff;
  overflow: hidden;
  position: absolute;
}
.preview-left {
  left: 0px;
}
.preview-right {
  right: 0px;
}
.preview-background {
  width: 100%;
  position: absolute;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/WebInboxPreview.vue